import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconPersonDetails(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="M2 7a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H2ZM1 12a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1ZM2 15a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2H2Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M14.75 8.75a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 1 1-5.5 0ZM12 15.625c0-1.829 3.664-2.75 5.5-2.75 1.836 0 5.5.921 5.5 2.75V17H12v-1.375Z"
        clipRule="evenodd"
      />
    </BaseIcon>
  );
}
